import useGetCustomers from './useGetCustomers'

export default useGetCustomers
